(function () {
  function contentText(key) {
    var source = document.querySelector("[data-bcw-interface-text]");
    return source ? source.getAttribute("data-" + key) || "" : "";
  }

  function setExpanded(header, expanded) {
    var toggle = header.querySelector("[data-bcw-menu-toggle]");
    var panel = header.querySelector("[data-bcw-mobile-menu]");

    if (!toggle || !panel) {
      return;
    }

    toggle.setAttribute("aria-expanded", String(expanded));
    toggle.setAttribute("aria-label", expanded ? contentText("menu-close") : contentText("menu-open"));
    panel.hidden = !expanded;
  }

  function initHeader(header) {
    if (header.dataset.bcwHeaderReady === "true") {
      return;
    }

    var toggle = header.querySelector("[data-bcw-menu-toggle]");
    var panel = header.querySelector("[data-bcw-mobile-menu]");

    if (!toggle || !panel) {
      return;
    }

    header.dataset.bcwHeaderReady = "true";

    toggle.addEventListener("click", function () {
      setExpanded(header, toggle.getAttribute("aria-expanded") !== "true");
    });

    panel.addEventListener("click", function (event) {
      if (event.target.closest("a")) {
        setExpanded(header, false);
      }
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        setExpanded(header, false);
      }
    });

    document.addEventListener("click", function (event) {
      if (!header.contains(event.target)) {
        setExpanded(header, false);
      }
    });
  }

  function initHeaders() {
    document.querySelectorAll("[data-bcw-header]").forEach(initHeader);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initHeaders);
  } else {
    initHeaders();
  }

  document.addEventListener("shopify:section:load", initHeaders);
})();
